import React from "react";
import styled from "./Skills.module.css";
import { AiFillGithub, AiOutlineHtml5 } from "react-icons/ai";
import {
  FaReact,
  FaNode,
  FaCss3Alt,
  FaLaravel,
  FaDatabase,
} from "react-icons/fa";
import {
  SiJavascript,
  SiBootstrap,
  SiNextdotjs,
  SiTailwindcss,
  SiExpress,
  SiMongodb,
  SiMysql,
  SiPhp,
} from "react-icons/si";

const skills = [
  { icon: AiOutlineHtml5, label: "HTML5" },
  { icon: FaCss3Alt, label: "CSS3" },
  { icon: SiBootstrap, label: "Bootstrap" },
  { icon: SiTailwindcss, label: "Tailwind" },
  { icon: SiJavascript, label: "JavaScript" },
  { icon: FaReact, label: "React.js" },
  { icon: SiNextdotjs, label: "Next.js" },
  { icon: FaNode, label: "Node.js" },
  { icon: SiExpress, label: "Express.js" },
  { icon: FaLaravel, label: "Laravel" },
  { icon: SiPhp, label: "PHP" },
  { icon: SiMysql, label: "MySQL" },
  { icon: SiMongodb, label: "MongoDB" },
  { icon: FaDatabase, label: "SQL" },
  { icon: AiFillGithub, label: "GitHub" },
];

const Skills = () => {
  return (
    <div id="skills" className={styled.section}>
      <h2 className={styled.heading}>
        <span className={styled.accent}>My</span> Skills
      </h2>

      <div className={styled.grid}>
        {skills.map(({ icon: Icon, label }) => (
          <div key={label} className={styled.card}>
            <Icon className={styled.icon} />
            <h3 className={styled.label}>{label}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
